import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './local';
import './i18n';
import 'mobily-ui-library/style.css';
import App from './App';
import './portal.css';
import AnalyticsScript from './Util/AnalyticsScript';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    {window.location.origin.includes("localhost") &&  <AnalyticsScript />}
    <App />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
